import React, { useEffect, useState } from "react";
import TypographyInline from "../../../../components/Typography/TypographyInline";
import SourceTypeChip from "./SourceTypeChip";
import {
  BORDER,
  GREY,
  PRIMARY,
  SUCCESS,
  HELP,
  ACTIONS,
} from "../../../../utils/constants/colors";
import {
  ICON_LABELS,
  fontSize,
  fontWeight,
} from "../../../../utils/constants/UI";
import classes from "./CrmComp.module.css";

import { Accordion } from "@mui/material";
import {
  AccordionDetails,
  AccordionSummary,
  HtmlEditor,
} from "../../../../components";

import IconComponent from "../../../../components/Icon/IconComponent";
import IconColoredComponent from "../../../../components/Icon/IconColoredComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { STRINGS } from "../../strings";
import {
  compressString,
  dateOnlyStringEmailLog,
  dateTimeStringEmailLog,
  removeTagStyleFromHtml,
} from "../../../../utils/helpers";
import { AutoCompleteWoBorder } from "../../../../components/Autocomplete/AutoCompleteWoBorder";
import CustomMenu from "../../../../components/Menu/CustomMenu";
import { Button } from "../../../../components/Buttons";
import CustomDatePickerWoBorder from "../../../../components/DatePicker/CustomDatePickerWoBorder";
import TimeSelector from "../../../../components/TimeSelector/TimeSelector";
import {
  sequenceEndPoints,
  taskEndpoints,
} from "../../../../utils/constants/httpConstants";
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
  putRequest,
} from "../../../../Apis/apiWrapper";
import {
  EMITTER_ERROR,
  EMITTER_SUCCESS,
  SEND_REMINDER,
  STEPS_PRIORITY_FIELDS,
  TIMEZONE_LIST,
} from "../../../../utils/constants";
import EventEmitter from "../../../../utils/emitter/EventEmitter";
import CallRecordingPlayer from "./CallRecordingPlayer";
import InputField from "../../../../components/InputFields/InputField";
import TaskDeleteModal from "./TaskDeleteModal";
import AddComment from "../../Components/AddComment";
import DeleteCommentModal from "../../Components/DeleteCommentModal";
import parse from "html-react-parser";
import { useSelector } from "react-redux";

const ListingTaskCard = ({
  id,
  logData,
  contact_id,
  setTaskListData,
  expanded,
  // When mounted inside a parent that already shows its own header (e.g.
  // a timeline row), suppress this card's own AccordionSummary and keep
  // it permanently expanded so just the body (title strip + priority/
  // due/time/reminder + description) is visible.
  hideHeader = false,
  // True when this row is a campaign-driven touch whose parent campaign
  // is still in "Ready To Run" / draft / queued - i.e. the touch hasn't
  // actually been scheduled yet. We hide the clock+date in the header and
  // render "--" for the four dropdowns so the UI doesn't imply a date or
  // priority that isn't real yet.
  isPreScheduled = false,
  type,
  showOperation = true,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [taskOpen, setTaskOpen] = useState(false);
  const [dueTime, setDueTime] = useState("00:00");
  const [actionMenuAnchor, setActionMenuAnchor] = useState(null);
  const [isActionMenuVisible, setIsActionMenuVisible] = useState(false);
  const [priorityType, setPriorityType] = useState([""] || []);
  const [priorityTypeId, setPriorityTypeId] = useState([""] || []);
  const [reminderType, setReminderType] = useState([""] || []);
  const [reminderTypeId, setReminderTypeId] = useState([""] || []);
  const [openTask, setOpenTask] = useState(false);
  const [ChangeField, setChangeField] = useState(false);
  const [changeIcon, setChangeIcon] = useState(false);
  const [visible, setVisible] = useState(false);
  const [description, setDescription] = useState("");
  const [dueDate, setDueDate] = useState(new Date());
  const [taskTitle, setTaskTitle] = useState("");
  const [commentBody, setCommentBody] = useState("");
  const [loader, setLoader] = useState(false);
  const [createCommentLoading, setCreateCommentLoading] = useState(false);
  const [taskLogCommentsPage, setLogTaskCommentsPage] = useState(0);
  const [isDeleteCommentLoading, setIsDeleteCommentLoading] = useState(false);
  const [deleteCommentModalOpen, setDeleteCommentModalOpen] = useState(false);
  const [clickedCommentData, setClickedCommentData] = useState({});
  const [taskLogComments, setTaskLogComments] = useState([]);
  const [editorView, setEditorView] = useState(false);
  const [notesClicked, setNotesClicked] = useState(false);
  console.log({ type });
  const UpdatedLocation = type === STRINGS.CALL;

  let offset = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timezone_objChange = TIMEZONE_LIST?.filter(
    (item) => item?.id === offset
  );

  const handleHover = () => {
    setChangeField(true);
  };

  const handleHoverLeave = () => {
    setChangeField(false);
  };

  const tableOperations = [
    // Pin entry hidden from the menu per UX request - kept here commented
    // out so we can re-enable without re-deriving the handler wiring.
    // {
    //   id: STRINGS.SMALL_PIN,
    //   label: logData?.pin === true ? STRINGS.UNPIN : STRINGS.PIN,
    //   iconLabel: ICON_LABELS.PUSH_PIN,
    //   function: () => handlePin(),
    // },

    {
      id: STRINGS.SMALL_COMPLETE,
      label: STRINGS.MARK_AS_COMPLETE,
      iconLabel: ICON_LABELS.CHECK_CIRCLE,
      function: () => handleConfirmStatus(),
      // #8: allow Mark-as-complete for calls too; hide only for ES-only sequence steps
      // and campaign-preview rows (no Mongo twin → update-task would 500) + already-done.
      // #13: a sequence or campaign call/task IS completable now - it just needed an endpoint
      // that can complete an Elasticsearch-only row. What still hides the action is the two
      // things that make it meaningless: already done, or cancelled (a cancelled step was never
      // performed, so "complete" would be a second untruth on top of the first).
      isVisible: !(
        logData?.status === true ||
        logData?.unenrolled === true ||
        ["suppressed", "unenrolled"].includes(
          String(logData?.campaign_status || "").toLowerCase(),
        )
      ),
    },
    {
      id: STRINGS.SMALL_DELETE,
      label: STRINGS.DELETE,
      iconLabel: ICON_LABELS.DELETE,
      function: () => handleTaskRecordDelete(),
      variant: "error",
    },
  ];

  const handleModal = (event) => {
    setIsActionMenuVisible(true);
    setActionMenuAnchor(event.currentTarget);
  };

  //Handling pin Action here
  const handlePin = async () => {
    let payload = {
      pin: !logData?.pin,
      _id: logData?._id,
    };
    try {
      const URL = sequenceEndPoints?.pinTaskCrm;
      const response = await putRequest(navigate, URL, payload);
      EventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);
      let url2 = `${taskEndpoints.getTaskListCrm}/${contact_id}?step_type=${UpdatedLocation ? 3 : 2
        }`;
      const responseGet = await getRequest(navigate, url2);
      setTaskListData?.(responseGet?.data?.data?.records);
    } catch (error) { }
  };

  //Mark as complete Handler
  const handleConfirmStatus = async () => {
    setChangeIcon(!changeIcon);

    // Sequence and campaign steps live only in Elasticsearch; /update-task goes through Mongo and
    // answers 500 for them, which is why this action used to be hidden for those rows entirely.
    const isEsOnlyStep =
      logData?.record_type_for_crm === "Sales Sequence" || !!logData?.from_campaign;

    if (isEsOnlyStep) {
      try {
        const response = await postRequest(
          navigate,
          sequenceEndPoints?.markStepComplete,
          { task_id: logData?._id, completed: !logData?.status },
        );
        EventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);
        const url = `${taskEndpoints.getTaskListCrm}/${contact_id}?step_type=${UpdatedLocation ? 3 : 2}`;
        const responseGet = await getRequest(navigate, url);
        setTaskListData?.(responseGet?.data?.data?.records);
      } catch (error) {
        // Put the tick back if the server refused - a cancelled step, for instance.
        setChangeIcon((v) => !v);
        EventEmitter.emit(
          EMITTER_ERROR,
          error?.data?.message || "Could not update this step",
        );
      }
      return;
    }

    let payload = {
      status: !logData?.status,
      id: logData?._id,
      offset: timezone_objChange[0]?.offset,
    };
    try {
      const URL = taskEndpoints?.updateTask;
      const response = await patchRequest(navigate, URL, payload);
      EventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);
      let url2 = `${taskEndpoints.getTaskListCrm}/${contact_id}?step_type=${UpdatedLocation ? 3 : 2
        }`;
      const responseGet = await getRequest(navigate, url2);

      setTaskListData?.(responseGet?.data?.data?.records);
    } catch (error) { }
  };

  //handling task Delete Record popup open state
  const handleTaskRecordDelete = async () => {
    setOpenTask(true);
  };

  //previous Duetime set here -setDueTime
  useEffect(() => {
    if (logData?.show_time_stamp) {
      let hours = new Date(parseInt(logData?.show_time_stamp)).getHours();
      let minutes = new Date(parseInt(logData?.show_time_stamp)).getMinutes();

      if (hours.toString().length === 1) {
        hours = "0" + hours;
      }
      if (minutes.toString().length === 1) {
        minutes = "0" + minutes;
      }
      const set = hours + ":" + minutes;

      setDueTime(set);
    } else {
      let hoursTime = new Date().getHours();
      let minutesTime = new Date().getMinutes();
      if (minutesTime >= 45) hoursTime++;
      hoursTime = hoursTime % 24;
      minutesTime += 15;
      minutesTime = minutesTime % 60;
      if (hoursTime.toString().length === 1) {
        hoursTime = "0" + hoursTime;
      }
      if (minutesTime.toString().length === 1) {
        minutesTime = "0" + minutesTime;
      }

      const setTiming = hoursTime + ":" + minutesTime;

      setDueTime(setTiming);
    }
    //set the previous data

    setDescription(logData?.notes);
    setPriorityTypeId([logData?.priority]);
    setPriorityType([logData?.priority]);
    setReminderTypeId([logData?.send_reminder]);
    setReminderType(
      logData?.send_reminder === 1 ? [STRINGS.YES] : [STRINGS.NO]
    );

    setDueDate(new Date(logData?.show_time_stamp));
    setTaskTitle(logData?.title);

    if (expanded) {
      setTaskOpen(expanded);
    }
  }, [logData]);

  const tenantUsersListSelector = useSelector(
    (state) => state?.tenantUsersList?.payload?.tenant_user_list?.data?.data
  );

  const updatedRecord = tenantUsersListSelector?.filter((eachRecord) => {
    return eachRecord?._id === logData?.user_id;
  })[0];

  // Campaign AND sales-sequence touches are queued by an engine: the stored
  // timestamp is an intent, not a commitment, so no clock time is shown for them —
  // only the date. Manual rows keep their exact due time because a human picked it.
  const isAutomatedTouch =
    ["marketing campaign", "sales sequence"].includes(
      String(logData?.record_type_for_crm || "").trim().toLowerCase(),
    ) || !!logData?.from_campaign;
  // NOTE: `status` deliberately not consulted for automated rows. The automated
  // campaign flow writes its task_index rows with status:true at CREATION time
  // (campaign_component builds the row before anything runs), so status says
  // nothing about whether the touch happened — trusting it made every campaign
  // call read "Call logged" before anyone dialled.
  const isPendingAutomatedTouch = isAutomatedTouch;

  // Header verb. A manual row reads "Call logged / Task created by X" because a
  // human did it. An engine-driven row must not claim it was logged — it is either
  // Scheduled (a real due date exists) or Schedule Pending (no date at all yet).
  const touchHeadline = (() => {
    const isCall = logData?.step_type === 3;
    if (isAutomatedTouch) {
      // Two independent pending signals: the parent campaign is still Ready To
      // Run (isPreScheduled), or the row itself carries no due date. The second
      // matters because the parent lookup misses whenever the campaign's activity
      // docs were stamped under a different contact_id than the one being viewed.
      if (isPreScheduled || !logData?.show_time_stamp) {
        return isCall
          ? STRINGS.CALL_SCHEDULE_PENDING
          : STRINGS.TASK_SCHEDULE_PENDING;
      }
      return isCall ? STRINGS.CALL_SCHEDULED : STRINGS.TASK_SCHEDULED;
    }
    return isCall ? STRINGS.CALL_LOGGED : STRINGS.TODO_CREATED;
  })();

  //Handling Edit Task Api
  const handleTaskEditApi = async () => {
    setLoader(true);

    try {
      let dateObj = dueDate;
      const NewDate = dueTime?.split(":").map(Number);
      let m = NewDate[1];
      let h = NewDate[0];
      let totalms = h * 60 * 60 * 1000 + m * 60 * 1000;
      let month = new Date(dateObj)?.getMonth() + 1;
      let day = new Date(dateObj)?.getDate();
      let year = new Date(dateObj)?.getFullYear();
      let newdate = year + "-" + month + "-" + day;

      let date;
      if (dueTime) {
        date = new Date(newdate).getTime() + totalms;
      } else {
        date = new Date(newdate).getTime();
      }
      const customEditorValue = description?.length
        ? `<div>${description}</div>`
        : "";
      // Backend rejects nulls on optional fields ("show_time_stamp must
      // be a valid date" / similar for priority + send_reminder). Build
      // the payload with required fields only and conditionally add the
      // optionals when they have real values - JSON.stringify will then
      // omit them entirely instead of sending null.
      const payload = {
        status: logData?.status,
        id: logData?._id,
        contact_id: contact_id,
        title: taskTitle,
        step_type: UpdatedLocation ? 3 : 2,
        notes: compressString(
          encodeURIComponent(removeTagStyleFromHtml(customEditorValue))
        ),
        offset: timezone_objChange[0]?.offset,
      };
      if (Number.isFinite(date) && !logData?.from_campaign) {
        payload.show_time_stamp = date;
      }
      if (priorityTypeId?.[0] && !logData?.from_campaign) {
        payload.priority = priorityTypeId[0];
      }
      const reminderInt = parseInt(reminderTypeId?.[0]);
      if (Number.isFinite(reminderInt) && !logData?.from_campaign) {
        payload.send_reminder = reminderInt;
      }
      const URL = taskEndpoints?.updateTask;
      const response = await patchRequest(navigate, URL, payload);
      let url2 = `${taskEndpoints.getTaskListCrm}/${contact_id}?step_type=${UpdatedLocation ? 3 : 2
        }`;
      const responseGet = await getRequest(navigate, url2);
      setTaskListData?.(responseGet?.data?.data?.records);
      EventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);

      setLoader(false);
      setEditorView(false);
      setVisible(false);
    } catch (error) {
      // console.log({ error });
      setLoader(false);
      // Backend validation errors arrive as
      //   { message: "Invalid data provided",
      //     data: { errors: { title: "...50 characters" } } }
      // Surface the first field-level message when present so the user sees
      // "The length of the task title should not exceed 50 characters."
      // instead of the generic "Invalid data provided".
      const fieldErrors =
        error?.data?.data?.errors || error?.response?.data?.data?.errors;
      const firstFieldError =
        fieldErrors && typeof fieldErrors === "object"
          ? Object.values(fieldErrors).find(
              (v) => typeof v === "string" && v.length > 0,
            )
          : null;
      const genericMessage =
        error?.data?.message || error?.response?.data?.message;
      EventEmitter.emit(EMITTER_ERROR, firstFieldError || genericMessage);
    }
  };

  useEffect(() => {
    if (taskOpen) {
      getTaskLogComments(false, true);
    }
  }, [taskOpen]);

  useEffect(() => {
    if (taskLogCommentsPage) {
      getTaskLogComments(true, false);
    }
  }, [taskLogCommentsPage]);

  // creating task log comment api handler
  const createCommentHandler = async () => {
    try {
      setLogTaskCommentsPage(0);
      let payload = {
        comment: commentBody,
        task_id: logData?._id,
      };
      setCreateCommentLoading(true);
      const response = await postRequest(
        navigate,
        sequenceEndPoints.createTaskCommentCrm,
        payload
      );
      getTaskLogComments(false, true);
      setCreateCommentLoading(false);
      EventEmitter.emit(EMITTER_SUCCESS, response.data.message);
    } catch (error) {
      EventEmitter.emit(EMITTER_ERROR, error?.data?.message);

      // console.log("Error ->>>>> ", error);
    }
  };

  // edit task log comment api handler
  const updateTaskLogCommentHandler = async (comment, editValue) => {
    try {
      setLogTaskCommentsPage(0);
      let payload = {
        comment: editValue[comment?.id],
        id: comment?.id,
      };
      const response = await putRequest(
        navigate,
        sequenceEndPoints.updateTaskCommentCrm,
        payload
      );
      getTaskLogComments(false, true);
      EventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);
    } catch (error) {
      EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
      // console.log("Error ->>>> ", error);
    }
  };

  // delete task log comment api handler
  const deleteTaskLogCommentHandler = async (data) => {
    try {
      setLogTaskCommentsPage(0);
      setIsDeleteCommentLoading(true);
      let url = `${sequenceEndPoints?.deleteTaskCommentCrm}/${data?.id}`;
      const response = await deleteRequest(url, {}, navigate);
      getTaskLogComments(false, true);
      setIsDeleteCommentLoading(false);
      setDeleteCommentModalOpen(false);
      EventEmitter.emit(EMITTER_SUCCESS, response?.data?.message);
    } catch (error) {
      EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
      // console.log("Error ->>>> ", error);
    }
  };

  const deleteTaskLogCommentModalHandler = (data) => {
    setClickedCommentData(data);
    setDeleteCommentModalOpen(true);
  };

  // api call for getting task log comments
  const getTaskLogComments = async (isOnScroll, initial) => {
    try {
      let url =
        sequenceEndPoints.getTaskCommentCrm +
        `/${logData?._id}?size=10&page=${initial ? 0 : taskLogCommentsPage}`;
      const response = await getRequest(navigate, url);
      if (isOnScroll) {
        setTaskLogComments([
          ...taskLogComments,
          ...response?.data?.data?.records,
        ]);
      } else {
        setTaskLogComments([...response?.data?.data?.records]);
      }
    } catch (error) {
      EventEmitter.emit(EMITTER_ERROR, error?.data?.message);
    }
  };

  const handleResetContDetails = () => {
    setVisible(false);

    let timeStamp =
      new Date(logData?.show_time_stamp)?.toTimeString().split(":")[0] +
      ":" +
      new Date(logData?.show_time_stamp)?.toTimeString().split(":")[1];
    setDescription(logData?.notes);
    setDueDate(new Date(logData?.show_time_stamp));
    setDueTime(timeStamp);
    setTaskTitle(logData?.title);
    setPriorityTypeId([logData?.priority]);
    setPriorityType([logData?.priority]);
    setReminderTypeId([logData?.send_reminder]);
    setReminderType(
      logData?.send_reminder === 1 ? [STRINGS.YES] : [STRINGS.NO]
    );
    document.getElementById(id).innerHTML = logData?.notes;
  };

  return (
    <div className={classes.HeadTaskContainer}>
      <Accordion
        className={classes.accrodionRoot}
        onChange={() => setTaskOpen(!taskOpen)}
        expanded={taskOpen}
      >
        {hideHeader ? (
          // Minimal collapsed header used inside the timeline detail:
          // chevron + colored icon + "Call: <subject>" / "Task: <subject>".
          // Same affordance as EmailSentList - starts collapsed, click to
          // open the description block below.
          <AccordionSummary
            className={classes.accordionSummary}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <div className={classes.summaryContainerCompact}>
              <div className={classes.summaryContainerTask}>
                <div className={classes.summaryRightSection}>
                  <IconComponent
                    color={GREY.TERTIARY}
                    fontSize={fontSize.DXS}
                    iconLabel={
                      taskOpen
                        ? ICON_LABELS.ACTION_ARROW
                        : ICON_LABELS.KEYBOARD_ARROW_RIGHT
                    }
                  />
                  <IconColoredComponent
                    variant={logData?.step_type === 3 ? "green" : "yellow"}
                    iconLabel={
                      logData?.step_type === 3
                        ? ICON_LABELS.CALL
                        : ICON_LABELS.TASK
                    }
                    color={logData?.step_type === 3 ? "green" : "yellow"}
                    size="small"
                  />
                  <TypographyInline
                    label={`${logData?.step_type === 3 ? "Call" : "Task"}: ${logData?.title || logData?.subject || ""}`}
                    size={"sm"}
                    fontWeight={fontWeight.SEMIBOLD}
                    color={GREY.PRIMARY}
                  />
                </div>
              </div>
            </div>
          </AccordionSummary>
        ) : (
        <AccordionSummary
          className={classes.accordionSummary}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          {" "}
          <div
            className={
              taskOpen
                ? classes.summaryContainerHeadsOpen
                : classes.summaryContainerHeads
            }
          >
            <div className={classes.summaryContainerTask}>
              {/* Pin indicator hidden per UX request. Restore with the
                  block below if Pin comes back into the menu. */}
              {/* {showOperation && logData?.pin ? (
                <div className={logData?.pin ? classes.defaultIcon : ""}>
                  <IconComponent
                    iconLabel={logData?.pin ? ICON_LABELS.PUSH_PIN : ""}
                    color={logData?.pin ? PRIMARY.W_400 : ""}
                    fontSize={fontSize.XS}
                  />
                </div>
              ) : (
                ""
              )} */}
              <div className={classes.summaryRightSection}>
                <IconComponent
                  color={GREY.TERTIARY}
                  fontSize={fontSize.DXS}
                  iconLabel={
                    taskOpen
                      ? ICON_LABELS.ACTION_ARROW
                      : ICON_LABELS.KEYBOARD_ARROW_RIGHT
                  }
                />

                <IconColoredComponent
                  variant={logData?.step_type === 3 ? "green" : "yellow"}
                  iconLabel={
                    logData?.step_type === 3
                      ? ICON_LABELS.CALL
                      : ICON_LABELS.TASK
                  }
                  color={logData?.step_type === 3 ? "green" : "yellow"}
                  size="small"
                />

                {logData?.step_type === 3 && logData?.call_source === "dialer" ? (
                  <>
                    <TypographyInline
                      color={GREY.PRIMARY}
                      label={`${updatedRecord?.first_name || ""} ${updatedRecord?.last_name || ""}`.trim() || "Someone"}
                      size={"sm"}
                      fontWeight={fontWeight.SEMIBOLD}
                      isNoWrap
                    />
                    <TypographyInline
                      color={GREY.SECONDARY}
                      label={"called"}
                      size={"sm"}
                      fontWeight={fontWeight.REGULAR}
                    />
                    {(logData?.first_name || logData?.last_name || logData?.email) && (
                      <TypographyInline
                        color={GREY.PRIMARY}
                        label={`${logData?.first_name || ""} ${logData?.last_name || ""}`.trim() || logData?.email}
                        size={"sm"}
                        fontWeight={fontWeight.SEMIBOLD}
                        isEllipses
                      />
                    )}
                  </>
                ) : (
                  <>
                    <TypographyInline
                      label={touchHeadline}
                      size={"sm"}
                      fontWeight={fontWeight.SEMIBOLD}
                      color={GREY.PRIMARY}
                    />
                    <TypographyInline
                      color={GREY.SECONDARY}
                      label={`${STRINGS.BY} ${updatedRecord?.first_name || ""} ${updatedRecord?.last_name || ""
                        }${logData?.first_name ? ` ${STRINGS.WITH}` : ""}`}
                      size={"sm"}
                      fontWeight={fontWeight.REGULAR}
                      isNoWrap
                    />
                    {logData?.first_name && (
                      <TypographyInline
                        color={GREY.PRIMARY}
                        label={
                          `${logData?.first_name || ""} ${logData?.last_name || ""
                          }` || `${logData?.email}`
                        }
                        size={"sm"}
                        fontWeight={fontWeight.SEMIBOLD}
                        isEllipses
                      />
                    )}
                  </>
                )}
                {/*
                  Source pill (Manual / Marketing Campaign / Sales
                  Sequence). Read straight off `record_type_for_crm` so all
                  three variants surface consistently across Calls / Tasks /
                  Emails tabs. Suppressed when the card is embedded inside
                  the timeline detail (showOperation === false) - the
                  timeline row owns the pill there.
                */}
                {showOperation && logData?.call_source !== "dialer" && (
                  <SourceTypeChip recordType={logData?.record_type_for_crm} />
                )}
                {showOperation && logData?.step_type === 3 && logData?.call_source === "dialer" && (
                  <span style={{ marginLeft: "8px", display: "inline-flex", alignItems: "center", height: "20px", padding: "0 10px", borderRadius: "999px", fontSize: "11.5px", fontWeight: 600, background: SUCCESS.W_50, color: SUCCESS.W_700, border: `1px solid ${SUCCESS.W_100}`, whiteSpace: "nowrap" }}>
                    Sales Call
                  </span>
                )}
                {/* Campaign call/task that was cancelled by an unenroll — mirrors the way
                    emails already read as "Unenrolled email to <contact>". Data comes from
                    the get-task merge (unenrolled / campaign_status). */}
                {/* Paused campaign: the header verb still reads "Call/Task Scheduled",
                    which is a lie while the campaign is stopped. Same pill treatment the
                    Emails tab and the timeline chip use, so the three agree. */}
                {showOperation &&
                  ["pause", "paused"].includes(
                    String(logData?.campaign_status || "").toLowerCase(),
                  ) && (
                    <span
                      style={{
                        marginLeft: "8px",
                        display: "inline-flex",
                        alignItems: "center",
                        height: "20px",
                        padding: "0 10px",
                        borderRadius: "999px",
                        fontSize: "11.5px",
                        fontWeight: 600,
                        background: "#FFF6E5",
                        color: "#B25E09",
                        border: "1px solid #FBE2BE",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Paused
                    </span>
                  )}
                {showOperation &&
                  (logData?.unenrolled === true ||
                    logData?.campaign_status === "unenrolled" ||
                    logData?.campaign_status === "suppressed") && (
                    <span
                      style={{
                        marginLeft: "8px",
                        display: "inline-flex",
                        alignItems: "center",
                        height: "20px",
                        padding: "0 10px",
                        borderRadius: "999px",
                        fontSize: "11.5px",
                        fontWeight: 600,
                        background: ACTIONS.DEFAULT,
                        color: GREY.SECONDARY,
                        border: `1px solid ${BORDER.DEFAULT}`,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {/* A parked row was cancelled by the sequence takeover, not by an
                          unenroll — saying "Unenrolled" for it would name the wrong action. */}
                      {logData?.campaign_status === "suppressed"
                        ? logData?.step_type === 3
                          ? "Call Cancelled"
                          : "Task Cancelled"
                        : logData?.step_type === 3
                          ? "Call Unenrolled"
                          : "Task Unenrolled"}
                    </span>
                  )}
              </div>

              <div className={classes.dateTimeTaskContainer}>
                {/*
                  Right-side clock + due date for Calls / Tasks tabs.
                  Reads `show_time_stamp` (the picked due-date) so the
                  header reflects when the touch is/was scheduled, not the
                  log-creation timestamp. Skipped entirely when no due
                  date is on the record.
                */}
                {showOperation && logData?.show_time_stamp ? (
                  <>
                    <IconComponent
                      iconLabel={ICON_LABELS.ACCESS_TIME}
                      fontSize={fontSize.MD}
                      color={GREY.SECONDARY}
                    />
                    <TypographyInline
                      color={GREY.SECONDARY}
                      fontWeight={fontWeight.REGULAR}
                      size={"sm"}
                      label={
                        isPendingAutomatedTouch
                          ? dateOnlyStringEmailLog(logData?.show_time_stamp)
                          : dateTimeStringEmailLog(logData?.show_time_stamp)
                      }
                    />
                  </>
                ) : null}

                {showOperation && (
                  <>
                    <div className={classes.verticalLine} />
                    <div
                      className={classes.moreOptionsIconContianer}
                      onClick={(e) => {
                        e?.stopPropagation();
                      }}
                    >
                      <IconComponent
                        color={GREY.TERTIARY}
                        fontSize={fontSize.MD}
                        iconLabel={ICON_LABELS.MORE_VERT}
                        onClick={handleModal}
                      />

                      <CustomMenu
                        items={tableOperations}
                        anchor={actionMenuAnchor}
                        open={isActionMenuVisible}
                        onClose={() => {
                          setIsActionMenuVisible(false);
                          setActionMenuAnchor(null);
                        }}
                        paperMenuClass={classes.dropdownMenuListing}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
            {/* Empty for dialer calls (no checkbox + title hidden) — don't render the empty box */}
            {logData?.call_source !== "dialer" && (
            <div
              onMouseEnter={taskOpen ? () => handleHover() : () => { }}
              onMouseLeave={taskOpen ? handleHoverLeave : () => { }}
              className={
                ChangeField && taskOpen
                  ? classes.CallTodesignBorderchangeOpen
                  : taskOpen
                    ? classes.CallTodesignBorderOpen
                    : classes.CallTodesignBorder
              }
            >
              {/* #13: the tick is available on sequence and campaign steps too now. Still hidden
                  on a cancelled one - there is nothing to complete. */}
              {logData?.unenrolled === true ||
              ["suppressed", "unenrolled"].includes(
                String(logData?.campaign_status || "").toLowerCase(),
              ) ? (
                ""
              ) : (
                <IconComponent
                  color={
                    changeIcon || logData?.status == true
                      ? SUCCESS.W_400
                      : BORDER.DARK
                  }
                  fontSize={fontSize.DXS}
                  iconLabel={
                    changeIcon || logData?.status == true
                      ? ICON_LABELS?.CHECK_CIRCLE
                      : ICON_LABELS.RADIO_BUTTON_UNCHECKED
                  }
                  onClick={(e) => {
                    e?.stopPropagation();

                    handleConfirmStatus();
                  }}
                />
              )}
              <div
                className={classes.WIDTh}
                onClick={(e) => {
                  setChangeField(true);
                }}
              >
                <div
                  onClick={(e) => {
                    e?.stopPropagation();
                  }}
                >
                  {" "}
                  {logData?.call_source === "dialer" ? null : ChangeField && taskOpen ? (
                    <InputField
                      size={"sm36"}
                      value={taskTitle}
                      onChange={(e) => {
                        e?.stopPropagation();
                        setTaskTitle(e?.target?.value);
                        setVisible(true);
                      }}
                    />
                  ) : (
                    <TypographyInline
                      label={`${taskTitle}` || `${logData?.title}`}
                      size={"sm"}
                      fontWeight={fontWeight.SEMIBOLD}
                      color={GREY.PRIMARY}
                    />
                  )}
                </div>
              </div>
            </div>
            )}
          </div>
        </AccordionSummary>
        )}
        <AccordionDetails>
          <div className={classes.taskDescriptionLabel}>
            <div className={classes.companyDetailMainContainer}>
              {/*
                Hide the priority / due date / time / reminder strip when the
                card is embedded inside the timeline (`hideHeader` doubles as
                a "compact mode" signal). The timeline only wants the
                description block - the parent row already conveys date/
                state via its own chip + date column, and the campaign
                payload doesn't have meaningful priority/reminder values.
              */}
              {/* Nothing about a not-yet-fired campaign step is editable here - no
                  priority/due-date/reminder column exists in scheduled_mail_contacts -
                  so the whole strip is skipped for from_campaign rows instead of
                  showing dead "--" placeholders. */}
              {!hideHeader && logData?.call_source !== "dialer" && !logData?.from_campaign && (
              <div className={classes.taskDetailsContainer}>
                <div>
                  {" "}
                  <TypographyInline
                    color={GREY.SECONDARY}
                    size={"sm"}
                    fontWeight={fontWeight.REGULAR}
                    label={STRINGS.PRIORITY_FCAPS}
                    isEllipses
                  />
                  {isPreScheduled ? (
                    <TypographyInline
                      label="--"
                      size={"sm"}
                      fontWeight={fontWeight.REGULAR}
                      color={GREY.SECONDARY}
                    />
                  ) : (
                    <AutoCompleteWoBorder
                      size={"sm36"}
                      setValueState={setPriorityType}
                      onChange={() => {
                        setVisible(true);
                      }}
                      id="priority"
                      items={STEPS_PRIORITY_FIELDS}
                      LeftIcon=""
                      placeholder={STRINGS.SET_PRIORITY}
                      valueState={priorityType}
                      idState={priorityTypeId}
                      setIdState={setPriorityTypeId}
                    />
                  )}
                </div>
                <div className={classes.verticalLine} />
                <div>
                  {" "}
                  <TypographyInline
                    color={GREY.SECONDARY}
                    size={"sm"}
                    fontWeight={fontWeight.REGULAR}
                    label={STRINGS.DUE_DATE}
                    isEllipses
                  />
                  {isPreScheduled ? (
                    <TypographyInline
                      label="--"
                      size={"sm"}
                      fontWeight={fontWeight.REGULAR}
                      color={GREY.SECONDARY}
                    />
                  ) : (
                    <CustomDatePickerWoBorder
                      disablePast={true}
                      value={dueDate}
                      onChange={(newValue) => {
                        setDueDate(newValue?.$d);
                        setVisible(true);
                      }}
                      size={"sm36"}
                    />
                  )}
                </div>
                {logData?.record_type_for_crm !== "Marketing Campaign" && (
                  <>
                    <div className={classes.verticalLine} />
                    <div>
                      {" "}
                      <TypographyInline
                        color={GREY.SECONDARY}
                        size={"sm"}
                        fontWeight={fontWeight.REGULAR}
                        label={STRINGS.TIME}
                        isEllipses
                      />
                      {isPreScheduled ? (
                        <TypographyInline
                          label="--"
                          size={"sm"}
                          fontWeight={fontWeight.REGULAR}
                          color={GREY.SECONDARY}
                        />
                      ) : (
                        <TimeSelector
                          time={dueTime}
                          setTime={(time) => {
                            setDueTime(time);
                            setVisible(true);
                          }}
                          removeBorder
                        />
                      )}
                    </div>{" "}
                  </>
                )}
                <div className={classes.verticalLine} />
                <div>
                  {" "}
                  <TypographyInline
                    color={GREY.SECONDARY}
                    size={"sm"}
                    fontWeight={fontWeight.REGULAR}
                    label={STRINGS.SEND_REMINDER_CAPS}
                    isEllipses
                  />
                  {isPreScheduled ? (
                    <TypographyInline
                      label="--"
                      size={"sm"}
                      fontWeight={fontWeight.REGULAR}
                      color={GREY.SECONDARY}
                    />
                  ) : (
                    <AutoCompleteWoBorder
                      size={"sm36"}
                      setValueState={setReminderType}
                      onChange={() => {
                        setVisible(true);
                      }}
                      items={SEND_REMINDER}
                      LeftIcon=""
                      placeholder={STRINGS.SET_REMINDER}
                      valueState={reminderType}
                      idState={reminderTypeId}
                      setIdState={setReminderTypeId}
                    />
                  )}
                </div>
              </div>
              )}

              {/* Called (live dialer) → clean summary: outcome pill + duration + direction + recording */}
              {logData?.step_type === 3 && logData?.call_source === "dialer" && (() => {
                const LBL = { fontSize: "10.5px", letterSpacing: "0.06em", textTransform: "uppercase", color: GREY.TERTIARY, fontWeight: 600 };
                const VAL = { fontSize: "13.5px", fontWeight: 600, color: GREY.PRIMARY };
                const d = logData?.call_disposition || "—";
                const tone = d === "Connected"
                  ? { bg: SUCCESS.W_50, fg: SUCCESS.W_600, bd: SUCCESS.W_200 }
                  : d === "Left voicemail"
                    ? { bg: HELP.W_50, fg: HELP.W_600, bd: HELP.W_200 }
                    : { bg: ACTIONS.DEFAULT, fg: GREY.SECONDARY, bd: BORDER.DEFAULT };
                const secs = Number(logData?.call_duration_seconds || 0);
                const durStr = `${Math.floor(secs / 60)}:${secs % 60 < 10 ? "0" : ""}${secs % 60}`;
                return (
                  <div style={{ padding: "14px 18px 6px", display: "flex", flexDirection: "column", gap: "14px" }}>
                    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-start", gap: "26px" }}>
                      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                        <span style={LBL}>Outcome</span>
                        <span style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: tone.bg, color: tone.fg, border: `1px solid ${tone.bd}`, borderRadius: "20px", padding: "3px 12px", fontSize: "13px", fontWeight: 600, width: "fit-content" }}>
                          <span style={{ width: "7px", height: "7px", borderRadius: "50%", background: tone.fg }} />{d}
                        </span>
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                        <span style={LBL}>Duration</span>
                        <span style={{ ...VAL, fontVariantNumeric: "tabular-nums" }}>{durStr}</span>
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                        <span style={LBL}>Direction</span>
                        <span style={{ ...VAL, textTransform: "capitalize" }}>{logData?.call_direction || "outbound"}</span>
                      </div>
                    </div>
                    {logData?.call_disposition === "Connected" && (logData?.recording_id || logData?.provider_call_id) ? (
                      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                        <span style={LBL}>Recording</span>
                        <CallRecordingPlayer
                          recordingId={logData?.recording_id}
                          providerCallId={logData?.provider_call_id}
                        />
                      </div>
                    ) : null}
                  </div>
                );
              })()}

              {logData?.notes ? (
                <div
                  className={`${classes.logEmailListSummaryLowerContainer} ${notesClicked ? classes.notesBackground : ""
                    }`}
                  onClick={() => {
                    setNotesClicked(true);
                  }}
                  onBlur={() => {
                    setNotesClicked(false);
                  }}
                >
                  <div>
                    <TypographyInline
                      color={GREY.PRIMARY}
                      label={STRINGS.DESCRIPTION}
                      size={"sm"}
                      fontWeight={fontWeight.REGULAR}
                    />
                  </div>
                  {editorView ? (
                    <div className={classes.htmlEditor}>
                      <HtmlEditor
                        isAddTagNotVisible={true}
                        isMeetingTagNotVisible={true}
                        isAITagNotVisible
                        isFocusNotRequired
                        id={id}
                        previosData={logData?.notes}
                        onInput={(event) => {
                          setDescription(event?.target?.innerHTML);
                          setVisible(true);
                        }}
                        editorHeight={"8.625vw"}
                      />
                    </div>
                  ) : (
                    <div
                      onClick={() => setEditorView(true)}
                      className={classes.parsedEmailLogData}
                    >
                      {parse(logData?.notes)}
                      <br />
                    </div>
                  )}
                  {visible ? (
                    <div className={classes.aboutFooter}>
                      <div>
                        <Button
                          label={STRINGS.CANCEL}
                          size={"sm36"}
                          variant={"ghost"}
                          onClick={() => {
                            handleResetContDetails();
                          }}
                        />
                      </div>
                      <div>
                        <Button
                          label={STRINGS.SAVE}
                          size={"sm36"}
                          variant={"primary"}
                          onClick={() => {
                            handleTaskEditApi();
                          }}
                          isLoading={loader}
                          disabled={showOperation ? false : true}
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : visible ? (
                <div className={classes.aboutFootervisible}>
                  <div>
                    <Button
                      label={STRINGS.CANCEL}
                      size={"sm36"}
                      variant={"ghost"}
                      onClick={() => {
                        handleResetContDetails();
                      }}
                    />
                  </div>
                  <div>
                    <Button
                      label={STRINGS.SAVE}
                      size={"sm36"}
                      variant={"primary"}
                      onClick={() => {
                        handleTaskEditApi();
                      }}
                      isLoading={loader}
                      disabled={showOperation ? false : true}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>

            {/* detail comment section */}
          </div>
          {showOperation && (
            <div
              className={
                logData?.notes
                  ? classes.taskLogListCommentContainer
                  : classes.taskLogListCommentContainer
              }
            >
              <AddComment
                createCommentHandler={createCommentHandler}
                value={commentBody}
                setValue={setCommentBody}
                isLoading={createCommentLoading}
                commentsList={taskLogComments}
                onScrollHandler={() =>
                  setLogTaskCommentsPage(taskLogCommentsPage + 1)
                }
                updateCommentHandler={updateTaskLogCommentHandler}
                deleteModalHandler={deleteTaskLogCommentModalHandler}
              />

              <DeleteCommentModal
                open={deleteCommentModalOpen}
                close={() => {
                  setDeleteCommentModalOpen(false);
                }}
                clickedData={clickedCommentData}
                deleteButtonLoading={isDeleteCommentLoading}
                deleteAPIHandler={deleteTaskLogCommentHandler}
              />
            </div>
          )}
        </AccordionDetails>
      </Accordion>
      {openTask && (
        <TaskDeleteModal
          id={logData?._id}
          openTask={openTask}
          setOpenTask={setOpenTask}
          contactId={contact_id}
          setTaskListData={setTaskListData}
        />
      )}
    </div>
  );
};

export default ListingTaskCard;
